var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayasugo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 67,
    viewBox: "0 0 65 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48113",
    "data-name": "Group 48113",
    transform: "translate(-19988 -4472.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1197",
    "data-name": "Ellipse 1197",
    transform: "translate(19988 4472.563)",
    fill: "none",
    stroke: "#1a99a6",
    strokeWidth: 7
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.5,
    cy: 33.5,
    rx: 32.5,
    ry: 33.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.5,
    cy: 33.5,
    rx: 29,
    ry: 30,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-crown",
    "data-name": "Icon awesome-crown",
    d: "M28.635,24.3H6.074a.87.87,0,0,0-.868.868V26.9a.87.87,0,0,0,.868.868H28.635A.87.87,0,0,0,29.5,26.9V25.164A.87.87,0,0,0,28.635,24.3ZM32.106,6.942a2.6,2.6,0,0,0-2.6,2.6,2.55,2.55,0,0,0,.239,1.074l-3.926,2.354a1.733,1.733,0,0,1-2.4-.629L19,4.61a2.6,2.6,0,1,0-3.287,0l-4.42,7.734a1.734,1.734,0,0,1-2.4.629L4.973,10.619A2.6,2.6,0,1,0,2.6,12.148a2.658,2.658,0,0,0,.418-.043L6.942,22.561H27.767L31.688,12.1a2.658,2.658,0,0,0,.418.043,2.6,2.6,0,1,0,0-5.206Z",
    transform: "translate(20003.145 4492.181)",
    fill: "#1a99a6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayasugo);
export default __webpack_public_path__ + "static/media/Payasugo.c2647179efe3416fd4535df3369d13a7.svg";
export { ForwardRef as ReactComponent };